import { createReducer, on } from '@ngrx/store';

import { CompanyUsersStateActions } from './company-users-state.actions';
import {
  companyUsersInitialState,
  companyUsersStateAdapter,
  CompanyUsersStateModel,
} from './company-users-state.model';

export const CompanyUsersStateReducer = createReducer<CompanyUsersStateModel>(
  companyUsersInitialState,

  on(CompanyUsersStateActions.setCompanyUsers, (state, { companyUsers }): CompanyUsersStateModel => ({
    ...companyUsersStateAdapter.setAll(companyUsers ?? [], state),
    isLoaded: true,
  })),

  on(CompanyUsersStateActions.fetchError, (state): CompanyUsersStateModel => ({
    ...state,
    isLoaded: true,
  })),

  on(CompanyUsersStateActions.appLogout, (): CompanyUsersStateModel => companyUsersInitialState)
);
